import { render } from "./UserDocumentView.vue?vue&type=template&id=619c5000&scoped=true"
import script from "./UserDocumentView.vue?vue&type=script&lang=js"
export * from "./UserDocumentView.vue?vue&type=script&lang=js"

import "./UserDocumentView.vue?vue&type=style&index=0&id=619c5000&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-619c5000"]])

export default __exports__